import { FC, useContext, useMemo } from 'react';

import { useQuery } from '@apollo/client';
import { Table } from '@smartshell/ui-kit';

import { AuthContext } from 'auth';
import { LocalizationContext } from 'localization';
import {
  GET_WORK_SHIFT_BY_ID,
  IWorkShiftByIdRequest,
  IWorkShiftByIdResponse,
} from 'schemas';
import { SettingsContext } from 'settings';

import { DATE_KEY } from './constants';
import { getColumns } from './utils';
import s from './WorkShiftPayments.module.scss';

interface IWorkShiftPaymentsProps {
  workShiftId: number;
}
export const WorkShiftPayments: FC<IWorkShiftPaymentsProps> = ({
  workShiftId,
}) => {
  const { t } = useContext(LocalizationContext);
  const {
    data: { permissions },
  } = useContext(AuthContext);
  const {
    state: {
      settings: { currency },
    },
  } = useContext(SettingsContext);

  const { data, loading } = useQuery<
    IWorkShiftByIdResponse,
    IWorkShiftByIdRequest
  >(GET_WORK_SHIFT_BY_ID, {
    variables: { id: workShiftId },
    skip: !permissions?.has('work_shift_browse'),
  });

  const COLUMNS = useMemo(() => getColumns(currency.sign, t), [t]);

  return (
    <Table
      data={data?.workShift.payments ?? []}
      columns={COLUMNS}
      isLoading={loading}
      emptyDataPlaceholder={t('workShift.details.data.error')}
      onRowClick={(event, row, table) => {
        table.toggleAllRowsSelected(false);
        row.toggleRowSelected(!row.isSelected);
      }}
      sortBy={[{ id: DATE_KEY, desc: true }]}
      className={s.table}
    />
  );
};
